import { basicFilterInitialState } from '../../../../../stateManagement/reduxUtil';
import { commonTypes } from '../../../../common/redux/actions/commonActions';
import { interfaceMappingActionType } from '../actions/actionTypes';
import { updateFilterConfig, updateTableConfig } from './utilities/utility';

export const REDUCER_NAME = 'InterfaceMappingFilterList';

const resetServerValue = (state, action) => ({
  ...state,
  serverRequestError: action.data && action.data.serverRequestError,
  loading: false,
});

const logImListReq = (state, action) => ({
  ...state,
  listRequest: action.data ? action.data : state.listRequest,
  listRequestedOn: new Date(),
  loading: true,
});

const getEditItemDetailsResponse = (state, action) => ({
  ...state,
  getEditItemDetails: action.data,
});

function InterfaceMappingFilterListConfig(state = { ...basicFilterInitialState }, action = null) {
  switch (action.type) {
    // config list column configuration
    case interfaceMappingActionType.UPDATE_IM_FILTER_CONFIG:
      return updateFilterConfig(state, action);
    case interfaceMappingActionType.UPDATE_TABLE_CONFIGURATION:
      return updateTableConfig(state, action);
    case interfaceMappingActionType.REMOVE_IM_USER_DEFAULT_FILTER:
      return {
        ...state,
        userDefaultFilter: null,
      };
    case interfaceMappingActionType.UPDATE_IM_COLUMN_CONFIG:
      return {
        ...state,
        listSortOptions: action.data.sortOptions,
        listColumnOrder: action.data.columnOrder,
      };
    default:
      return null;
  }
}

function InterfaceMappingFilterListREQRES(state = { ...basicFilterInitialState }, action = null) {
  switch (action.type) {
    // log request
    case interfaceMappingActionType.LOG_IM_LIST_REQUEST:
      return logImListReq(state, action);
      // log error
    case interfaceMappingActionType.GET_IM_LIST_ERROR:
      return {
        ...state,
        listRequestError: action.data,
        listRequestProcessedOn: new Date(),
        loading: false,
      };
      // store response
    case interfaceMappingActionType.GET_IM_LIST_RESPONSE:
      return {
        ...state,
        listData: action.data,
        listRequestError: null,
        listRequestProcessedOn: new Date(),
        loading: false,
      };
    case interfaceMappingActionType.GET_IM_BY_ID_RESPONSE:
      return getEditItemDetailsResponse(state, action);
    case interfaceMappingActionType.RESET_IM_STORE:
      return {
        ...state,
        listData: null,
        listRequestError: null,
        listRequestProcessedOn: null,
        serverRequestError: null,
        loading: false,
      };
    case interfaceMappingActionType.RESET_SERVER_VALUE:
      return resetServerValue(state, action);
    case commonTypes.RESETSTORE:
      return basicFilterInitialState;
    default:
      return null;
  }
}

const InterfaceMappingFilterList = (state = { ...basicFilterInitialState }, action = null) => {
  const stateConfig = InterfaceMappingFilterListConfig(state, action);
  const stateReqRes = InterfaceMappingFilterListREQRES(state, action);
  if (stateConfig !== null) {
    return stateConfig;
  }
  if (stateReqRes !== null) {
    return stateReqRes;
  }
  return state;
};

export default InterfaceMappingFilterList;
